import React from "react";
import "./AccessibilityPlan.scss";
import ContactForm from "../../common-ui/contact-form/ContactForm";

const AccessibilityPlan: React.FC = () => {
  return (
    <div className="accessibility-plan">
      <div className="accessibility-container">
        <header className="accessibility-header">
          <h1>Accessibility Plan</h1>
        </header>

        <div className="accessibility-columns">
          {/* Left Column - Content */}
          <main className="accessibility-content">
            <section className="accessibility-section">
              <h2>Our Commitment to Accessibility</h2>
              <p>
                At Hot Freight International, accessibility is more than a
                policy — it’s part of who we are. We are dedicated to creating
                environments where everyone can participate, engage, and
                succeed. Through continuous improvements to our facilities,
                services, and communication tools, we aim to meet and exceed the
                highest accessibility standards for our customers, partners,
                employees, visitors, and applicants.
              </p>
            </section>

            <section className="accessibility-section">
              <h2>Our DEIB Committee</h2>
              <p>
                Our Diversity, Equity, Inclusion, and Belonging (DEIB) Committee
                plays a key role in identifying and removing accessibility
                barriers across our organization. We see this as an ongoing
                journey, with regular reviews to ensure we’re always improving.
                By taking proactive steps, we are building a culture that is
                more inclusive, equitable, and welcoming for everyone.
              </p>
            </section>

            <section className="accessibility-section">
              <h2>Our Accessibility Plan</h2>
              <p>
                In accordance with the Accessible Canada Act (ACA) and the
                Accessible Canada Regulations, we have developed this
                Accessibility Plan for Polaris Transport Carriers Inc. This is a
                living document that will be reviewed and updated annually to
                reflect progress, address new challenges, and strengthen our
                commitment to accessibility.
              </p>
            </section>

            <section className="accessibility-section">
              <h2>Contact Information</h2>
              <div className="contact-methods">
                <div className="contact-method">
                  <h3>General & Website Accessibility Feedback</h3>
                  <ul>
                    <li>
                      <strong>Email:</strong>{" "}
                      <a href="mailto:info@shiphotfreight.com">
                        info@shiphotfreight.com
                      </a>
                    </li>
                    <li>
                      <strong>Phone:</strong> 905-363-1865
                    </li>
                    <li>
                      <strong>Mail:</strong> 3580 Odyssey Drive, Mississauga, ON
                      L5M 0Z9 Canada L4T 3G7
                    </li>
                  </ul>
                </div>
                {/* 
                <div className="contact-method">
                  <h3>Website Accessibility</h3>
                  <ul>
                    <li>
                      <strong>Email:</strong>{" "}
                      <a href="mailto:marketing@polaristransport.com">
                        info@shiphotfreight.com
                      </a>
                    </li>
                    <li>
                      <strong>Phone:</strong> 877.468.0101
                    </li>
                    <li>
                      <strong>Mail:</strong> 2188 Mason St #160, Abbotsford, BC
                      V2T 0J8
                    </li>
                  </ul>
                </div> */}
              </div>
            </section>
          </main>

          {/* Right Column - Form */}
          <aside className="accessibility-form">
            <div className="form-container">
              <h2 className="form-heading">Contact Us About Accessibility</h2>
              <p className="form-subheading">
                Have feedback or questions? We’re here to listen.
              </p>
              <ContactForm />
            </div>
          </aside>
        </div>
      </div>
    </div>
  );
};

export default AccessibilityPlan;
